import React from 'react';

const XIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

interface DillModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: string;
  width?: string;
  contentClassName?: string;
  closeOnOverlayClick?: boolean;
  overlayZIndex?: number;
}

export const DillModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  maxWidth = '480px',
  width,
  contentClassName,
  closeOnOverlayClick = false,
  overlayZIndex,
}: DillModalProps) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 bg-black/40"
      style={{ zIndex: overlayZIndex ?? 50 }}
      onClick={closeOnOverlayClick ? onClose : undefined}>
      <div
        className="w-full bg-white rounded-2xl shadow-2xl flex flex-col max-h-[90svh]"
        style={{ maxWidth, width }}
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between px-5 py-4 border-b border-gray-100 shrink-0">
          <div>
            <p className="text-sm font-semibold text-gray-900">{title}</p>
            {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 cursor-pointer bg-transparent border-none mt-0.5">
            <XIcon />
          </button>
        </div>
        <div
          className={
            contentClassName ?? 'flex-1 min-h-0 overflow-y-auto px-5 py-4 flex flex-col gap-3.5'
          }>
          {children}
        </div>
        {footer && (
          <div className="flex items-center justify-end gap-2 px-5 py-3.5 border-t border-gray-100 shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};
